import React, { useEffect, useRef, useState } from 'react'
import Button from '../../components/button/Button'
import useScreenSize from '../../hooks/useScreenSize'
import { useDispatch, useSelector } from 'react-redux'
import {
  archiveCourse,
  assignBranchToCourse,
  getBranchList,
  getCourse,
} from '../../store/builders/course/course.builder'
import PageDropdown from '../../components/page-dropdown/PageDropdown'
import PopupBox from '../../components/popup/PopupBox'
import exporticon from '../../assets/icons/FileExport1.svg'
import pencilicon from '../../assets/icons/pencil1.svg'
import HorizontalLine from '../../assets/icons/Line33.svg'
import ArchiveIcon from '../../assets/icons/archive.svg'
import ModalUnstyled from '../../components/model/Model'
import ParentDataTable from '../../components/data-table/ParentDataTable'
import { useNavigate } from 'react-router-dom'
import { numbers, permissions, ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import PopupUpHover from '../../components/popuphover/PopUpHover'
import LocationMarker from '../../assets/icons/marker1.svg'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import clsx from 'clsx'
import { clearExtraReducers, resetCourseState } from '../../store/slice/course/course.slice'
import { capitalizeFirstLetter, formatDateToUTC } from '../../utility/genricFunction'
import { toast } from 'react-toastify'
import UseAuthorization from '../../utility/useAuthorization'
import Loader from '../../components/loader/Loader'

function ViewCourseList() {
  const dispatch = useDispatch()
  const { loading, course } = useSelector((state) => state.course)

  const selector = useSelector((store) => store.auth)

  const userRole = selector?.user?.result?.userData?.roleName

  const screenSize = useScreenSize()

  const [isCourseForm, setIsCourseForm] = useState(false)
  const [open, setOpen] = React.useState(false)
  const popupRef = useRef(null)
  const [isOpen, setIsOpen] = useState(false)
  const [assignBranchId, setAssignBranchId]= useState('')
  const [archiveId, setArchiveId] = useState('')
  const { branchList } = useSelector((store) => {
    return store.course
  })

  useEffect(() => {
    return () => {
      dispatch(clearExtraReducers())
    }
  }, [dispatch])

  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)

  const navigate = useNavigate()

  useEffect(() => {
    dispatch(getCourse())
    dispatch(getBranchList())
    return () => dispatch({ type: 'course/clearExtraReducers' })
  }, [])

  const countryBodyTemplate = (course) => {
    return (
      <PopupUpHover rowData={course}>
        <div className='allcourse-branch-popup'>
          <p className='allcourse-branch-popup-header'>BRANCH</p>
          {course.course_branches.map((i,index) => {
            return (
              <div className='allcourse-branch-popup-marker' key={index}>
                <img src={LocationMarker} alt='' />
                <p className='verifiedBodyTemplate-darkfont'>{capitalizeFirstLetter(i?.branch?.branch_name)}</p>
              </div>
            )
          })}
        </div>
      </PopupUpHover>
    )
  }

  const statusBody = (course) => {
    const representative = capitalizeFirstLetter(course.courseStatus)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const dateBody = (course) => {
    let date = new Date(course.createdAt)
    let formattedDate = formatDateToUTC(date)

    return (
      <div className='flex align-items-center gap-2'>
        <span>{formattedDate}</span>
      </div>
    )
  }

  const [openArchive, setOpenArchive] = React.useState(false)
  const handleArchive = (courseId) => {setOpenArchive(true)
    setIsOpen(true)
    setArchiveId(courseId)

  }

  const [selectedButtons, setSelectedButtons] = React.useState([])
  const toggleButton = (buttonId) => {
    setSelectedButtons((prevSelected) => {
      if (prevSelected.includes(buttonId)) {
        return prevSelected.filter((id) => id !== buttonId)
      } else {
        return [...prevSelected, buttonId]
      }
    })
  }

  const handleAssignBranch = (courseId) => {
    dispatch(assignBranchToCourse({ selectedButtons, courseId, dispatch }))
  }

  const handleCourseArchive = (courseId) => {
    dispatch(archiveCourse({ courseId, toast, dispatch }))
  }

  const verifiedBodyTemplate = (course) => {
    return (
      <>
        <PopupBox rowData={course} setIsOpen={setIsOpen} isOpen={isOpen} popupRef={popupRef} >
          <div className='popupbox'>
            {userRole?.toLowerCase() == 'admin' && (
              <>
                {UseAuthorization(permissions.ASSIGN_TO_BRANCH) &&
                <>
                <p className='verifiedBodyTemplate-Assign'>ASSIGN</p>
                <button
                  className='div-assign-to-branch'
                  disabled={course?.courseStatus == 'archive' ? true : false}
                  onClick={() => {
                    setOpen(true)
                    const branchIds = course.course_branches.map((branch) => {
                      return branch.branch.branch_id
                    })
                    setSelectedButtons(branchIds)
                    setIsOpen(true)
                    setAssignBranchId(course.courseId)
                  }}
                >
                  <img src={exporticon} alt='' />
                  <p
                    className={`${course?.courseStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
                  >
                    Assign to Branch
                  </p>
                </button>
                </>
                }
                
              </>
            )}

            
              <img src={HorizontalLine} alt='' />
            {UseAuthorization(permissions.EDIT_COURSE) && <>
              <p
              className={`${course?.courseStatus == 'archive' ? 'verifiedBodyTemplate-Edit popup-font' : 'verifiedBodyTemplate-Edit'}`}
            >
              EDIT
            </p>
              <button
              className='div-assign-to-branch'
              disabled={course?.courseStatus == 'archive' ? true : false}
              onClick={() => {
                navigate(ROUTES_PATH.EDIT_COURSE_INFORMATION.replace(':id', course.courseId))
              }}
            >
              <img src={pencilicon} alt='' />
              <p
                className={`${course?.courseStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
              >
                Course Information
              </p>
            </button>
            </>}


            {UseAuthorization(permissions.EDIT_COURSE) && <button
              className='div-assign-to-branch'
              disabled={course?.courseStatus == 'archive' ? true : false}
              onClick={() => {
                navigate(ROUTES_PATH.EDIT_COURSE_CONTENT.replace(':id', course.courseId))
              }}
            >
              <img src={pencilicon} alt='' />
              <p
                className={`${course?.courseStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
              >
                Course Content
              </p>
            </button>}
            

            {UseAuthorization(permissions.EDIT_COURSE) && <button
              className='div-assign-to-branch'
              disabled={course?.courseStatus == 'archive' ? true : false}
              onClick={() => {
                navigate(ROUTES_PATH.EDIT_COURSE_PRICING.replace(':id', course.courseId))
              }}
            >
              <img src={pencilicon} alt='' />
              <p
                className={`${course?.courseStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
              >
                Course Pricing
              </p>
            </button>}
            
            
            {UseAuthorization(permissions.ARCHIVE_COURSE) && <>
              <img src={HorizontalLine} alt='' />
            <button
              disabled={course?.courseStatus == 'archive' ? true : false}
              className='div-assign-to-branch archive'
              // disabled={course.course_branches.length || course.batches.length > 0 || course.courseStatus === 'archive'}
              onClick={()=>handleArchive(course.courseId)}
            >
              <img src={ArchiveIcon} alt='' />
              <p
                className={`${course?.courseStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
              >
                Archive
              </p>
            </button>
            </>}

            

          </div>

        </PopupBox>
          {open && (
            <ModalUnstyled
              open={open}
              setOpen={setOpen}
              title={'Assign to Branch'}
              BottomButton={'Assign Now'}
              handleAssignBranch={() => {
                handleAssignBranch(assignBranchId)
              }}
              className={'inventory-model'}
              backgroundColor='rgb(0 0 0 / 0.1)'
            >
              {branchList?.length && branchList.map((branch) => (
                <button
                  key={branch.id}
                  id={`styled-modal-description-${branch.branchId}`}
                  className={clsx('modal-description', {
                    selected: selectedButtons.includes(branch.branchId),
                  })}
                  onClick={() => toggleButton(branch.branchId)}
                >
                  {branch.branchName}, {branch.branchCity}
                </button>
              ))}
            </ModalUnstyled>
          )}

          {openArchive && (
            <ModalUnstyled
              open={openArchive}
              setOpen={setOpenArchive}
              title={'Archive'}
              BottomButton={'Yes'}
              BottomButton2={'No'}
              handleCourseArchive={() => {
                handleCourseArchive(archiveId)
              }}
              className={'archive-model'}
              backgroundColor='rgb(0 0 0 / 0.1)'
            >
              <div className='model-archive'>
                <p>{UI_CONSTANT.ARCHIVE_MESSAGE}</p>
              </div>
            </ModalUnstyled>
          )}
      </>
    )
  }

  const columns = [
    {
      sortable: true,
      field: 'courseName',
      header: 'Course Name',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
    },
    {
      sortable: true,
      field: 'courseStatus',
      header: 'Status',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      body: statusBody,
    },
    {
      sortable: true,
      field: 'courseBranchesCount',
      header: 'Branch',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      body: countryBodyTemplate,
    },
    {
      sortable: true,
      field: 'createdAt',
      header: 'Date',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      body: dateBody,
    },
    {
      sortable: false,
      field: 'verified',
      header: '',
      dataType: 'boolean',
      style: { maxWidth: '4rem' },
      body: verifiedBodyTemplate,
      filter: false,
    },
  ].filter((column) => {
    if (column.field.toLowerCase() == 'branch' && userRole.toLowerCase() == 'branch') {
      return false
    } else {
      return true
    }
  })

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.COURSE.LABLE_COURSE,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.COURSE.LABLE_COURSE,
      link: ROUTES_PATH.COURSE,
    },
  ]

  return (
    <>
    {loading && <Loader loading={loading} />}

   {<Loader loading={loading} /> &&  <div className={`course-list ${screenSize}`}>
      <div className='filter-bar-wraper'>
        {/* <div className='course-course'>{`Course >> Course List >> Add New Course`}</div> */}
        <div className='subheader'>
          <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />

        {UseAuthorization(permissions.ADD_COURSE) && <Button
            // icon={`${isCourseForm ? '' : 'add'}`}
            className={'add-btn'}
            onClick={() => {
              setIsCourseForm((rev) => !rev)
              navigate(ROUTES_PATH.ADD_COURSE_INFORMATION)
              dispatch(resetCourseState())
            }}
          >
            {isCourseForm ? UI_CONSTANT.BACK : UI_CONSTANT.COURSE.ADD_COURSE}
          </Button>}
        </div>
      </div>
      {!isCourseForm && (
        // <div className='group-parent'>
        <div className='group-parent'>
          <div className='frame-wrapper'>
            <div className='course-list-wrapper'>
              <b className='course-list1'>{UI_CONSTANT.COURSE.COURSE_TABLE_HEADER}</b>
            </div>
          </div>
          <div className='flex page-drop-div'>
            <p className='page-sidetext'>{UI_CONSTANT.TABLE_HEADER_SAW}</p>
            <PageDropdown
              options={numbers}
              selectedValue={selectedNumber}
              onChange={(e) => setSelectedNumber(e.value)}
              className='w-full md:w-14rem small-dropdown'
            />
            <p className='page-endtext'>{UI_CONSTANT.TABLE_HEADER_ENTRIES}</p>
          </div>

          {/* <div className='table-card ' style={{ padding: '1rem 1rem' }}> */}
          <div className='table-card action-btn-include'>
            <ParentDataTable
              value={course}
              rows={selectedNumber}
              // loading={loading}
              columns={columns}
              archiveKey='courseStatus'
            />
          </div>
        </div>
      )}

      {/* {isCourseForm && <AddCourses />} */}
    </div>}
    </>
  )
}

export default ViewCourseList
